import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';
import { WorkspaceTableRowSkeleton } from './workspace-table-row-skeleton';

const cardCss = css`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  width: 100%;
  max-width: 750px;
  background: ${theme.colors.white};
  box-shadow: 0px 1px 3px 1px rgba(0, 33, 82, 0.15), 0px 1px 1px rgba(0, 33, 82, 0.15);
  border-radius: 8px;
  box-sizing: border-box;
`;

const tabBarCss = css`
  display: flex;
  gap: ${theme.spacing(3)};
  border-bottom: 2px solid ${theme.colors.neutral20};
  padding-bottom: ${theme.spacing(1.5)};
  margin-bottom: ${theme.spacing(2)};
`;

const sectionHeaderCss = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing(1.5)};
`;

const tableHeaderCss = css`
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #8e959e;
  margin-bottom: ${theme.spacing(0.5)};
`;

const ROW_COUNT = 4;

export function WorkspaceDetailSkeleton() {
  return (
    <div css={cardCss}>
      {/* Tab bar */}
      <div css={tabBarCss}>
        <SkeletonLoader width={52} height={20} />
        <SkeletonLoader width={76} height={20} />
      </div>

      {/* Section header: title + add button */}
      <div css={sectionHeaderCss}>
        <SkeletonLoader width={148} height={26} />
        <SkeletonLoader width={100} height={34} />
      </div>

      {/* Table column header */}
      <div css={tableHeaderCss}>
        <SkeletonLoader width={60} height={16} />
      </div>

      {/* Table rows */}
      {Array.from({ length: ROW_COUNT }).map((_, i) => (
        <WorkspaceTableRowSkeleton key={i} hasAvatar />
      ))}
    </div>
  );
}
